import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_insert_shipment_payload_to_stagingService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { shipmentPayload: $types.Ultraship.ShipmentWS, storageMessageId?: string, storageTransactionId?: string }): Promise<{ outputDetails?: string[], debugDetails?: string[], success?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentPayload)) {
      missingRequiredInParams.push('\'shipmentPayload\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/insert_shipment_payload_to_staging`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

